.popoverContainer {
  background-color: var(--via-color-neutral-000);
  border-radius: var(--via-space-400);
  box-shadow: 0px 2px 4px -1px var(--via-color-neutral-400);
  display: flex;
  flex-direction: column;
  padding: var(--via-space-400);

  max-height: 400px;
  overflow-y: scroll;
}
